/**
 * Helper sort function.
 * @param valueA the value A
 * @param valueB the value B
 */
export function compareValues(valueA: string | null | undefined, valueB: string | null | undefined): number {
  let compareValue = 0;
  if (valueA && valueB)
    compareValue = valueA.localeCompare(valueB);
  else if (valueA)
    compareValue = 1;
  else if (valueB)
    compareValue = -1;
  return compareValue;
}
